<avi-state-page
    class="system-update clr-wrapper"
    [hasSidebar]="true"
>
    <avi-state-page_main-content>
        <avi-alert-group
            *ngIf="fipsFailure"
            alertType="warning"
        >
            <span>{{ l10nKeys.nonOperationalFipsMessage | vtranslate }}</span>
        </avi-alert-group>
        <div class="system-update__container">
            <system-update-about-card
                class="system-update__update-card"
                [enableRollback]="enableRollback && !isSystemUpdateInProgress"
                [rollbackOptions]="rollbackOptions"
                (onSelectRollbackOption)="onRollbackOptionClick($event)"
                [systemConfig]="systemConfig"
                [fipsOperational]="fipsOperational"
                (onRestoreClick)="openRestoreWizard()"
                [isUpgradeOperationInProgress]="isSystemUpdateInProgress || arePreChecksInProgress"
            ></system-update-about-card>
            <update-progress-card
                class="system-update__update-card"
                [fipsOperational]="fipsOperational"
                [isControllerUpgrade]="isControllerUpgrade"
                (checkWizardStatus)="openProgressWizard($event)"
                [isWizardOpen]="isWizardOpen"
            ></update-progress-card>
        </div>
        <avi-collection-data-grid
            [config]="imageCollectionGridConfig"
            gridTitle="{{ l10nKeys.availableUpdatesLabel | vtranslate : imageCollection.itemList.length }}"
        ></avi-collection-data-grid>
    </avi-state-page_main-content>
    <avi-state-page_sidebar>
        <div
            *ngIf="!isInitialConfigSet"
            class="system-update__setup-info"
        >
            <clr-spinner
                clrMedium
                class="system-update__loader"
            ></clr-spinner>
            <span class="system-update__setup-info-label">{{ l10nKeys.loadingRecentLabel | vtranslate }}</span>
        </div>
        <recent-updates-list
            *ngIf="isInitialConfigSet"
            [nodeType]="upgradeNodeType"
            [preCheckNodes]="preCheckNodes | async"
            [preChecksTriggered]="arePreChecksTriggered$ | async"
            [overallPreChecksState]="overallPreChecksState$ | async"
            [isDryRunFlow]="isDryRunFlow"
            [dryRunNodes]="dryRunNodes$ | async"
        ></recent-updates-list>
    </avi-state-page_sidebar>
</avi-state-page>

<ng-template
    #imageTypeTemplateRef
    let-row
>
    <div>
        <cds-icon
            [shape]="row.isType('IMAGE_TYPE_SYSTEM') ? 'display' : 'wrench'"
            size="18"
        ></cds-icon>
        <span> {{ row.type | enumValueLabel : 'ImageType' }}</span>
    </div>
</ng-template>

<update-wizard
    [upgradeConfig]="upgradeConfig"
    [isSystemUpdate]="true"
    [isWizardOpen]="isWizardOpen"
    [isRestore]="isRestore"
    [isRollback]="isRollback"
    [systemReportId]="systemReportId"
    (onSelectSegUpdate)="handleSelectSegUpdate($event)"
    (onClose)="onClose()"
    [currentUpdateWizardStage]="currentUpdateWizardStage"
    [preCheckProgressConfig]="progressWizardInfo"
></update-wizard>
